<template>
  <div class="vehicles">
    <section class="section-header">
      <h1>{{ $t('user.account') }}</h1>
      <div class="meta"></div>
    </section>

    <div class="body-content">
      <UserBaseData
        :templateMode="'edit'"
        :title="$t('user.editAccount')"
        :user="user"
        :onSubmitBaseData="updateUserData"
      />

      <div class="content-wrap">
        <Form :bodyClass="''" :title="$t('user.settings')" @submit="updateUserSettings">
          <div class="form-wrap">
            <label for="report_threshold">{{ $t('user.reportThreshold.label') }}</label>
            <div class="form-wrap--inline">
              <span class="prefix">{{ $t('user.reportThreshold.prefixInput') }}</span>
              <input
                v-model="formattedUserThreshold"
                class="form-input"
                type="number"
                min="1"
                max="100"
                name="report_threshold"
                id="report_threshold"
              />
              <span class="suffix">{{ $t('user.reportThreshold.suffixInput') }}</span>
            </div>
          </div>
          <Button type="submit" fullWidth>{{ $t('meta.save') }}</Button>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import Button from '@/components/Button/index.vue'
import Form from '@/components/Form/index.vue'
import UserBaseData from '@/components/UserBaseData'

import usersApi from '@/api/users'
import { mapSettings } from '@/utils/settings'

export default {
  name: 'user_show',
  components: {
    Button,
    Form,
    UserBaseData,
  },
  data() {
    return {
      loading: true,
      user: {},
    }
  },
  computed: {
    ...mapSettings(['userLanguage']),
    formattedUserThreshold: {
      get: function () {
        return 'report_threshold' in this.user ? Math.round(this.user.report_threshold * 100) : null
      },
      set: function (newValue) {
        this.user.report_threshold = newValue / 100
      },
    },
  },
  methods: {
    async getData() {
      this.user = await usersApi.getCurrent()
    },
    async updateUserData(userData) {
      const result = await usersApi.update(userData)
      if (result.success) {
        this.user = result.user
        this.$i18n.locale = this.user.language
        this.userLanguage = this.user.language
        document.documentElement.lang = this.user.language
        await this.getData()
        location.reload()
      }
    },
    async updateUserSettings() {
      const result = await usersApi.update(this.user)
      if (result.success) {
        this.user = result.user
        await this.getData()
      }
    },
  },
  async mounted() {
    await this.getData()
  },
}
</script>
